import _ from "lodash";
import {
  dashboardColor,
  globeColor,
  archiveColor,
  managerColor,
  postmasterColor,
  delegateColor,
  importsColor,
  migrationsColor,
  etliveColor,
  registerColor,
  customizationsColor,
  supportColor,
  emailDelivery,
  users,
  suppressionList,
} from "Icons/index";
import QboxmailApi from "../../qboxmailApi";

//eslint-disable-next-line
function goToWHMCSTicketPage(tm) {
  let win = window.open("about:blank", "_blank");
  win.focus();
  const api = new QboxmailApi({ useCookie: true });
  return api
    .generateWHMCSUrl("get_support_url")
    .then((r) => {
      win.location.replace(r.resources[0].url);
    })
    .catch((response) => {
      console.log("error generating whmcs support link", response);
    });
}

export default (tm, router, isDelivery = false) => {
  const canSeeDelivery = tm.permissions.includes("see_delivery");
  const canSeeDeliveryTracemail = tm.permissions.includes("see_delivery_tracemail");
  const canSeeSuppressionList = tm.permissions.includes("see_suppression_list");

  if (isDelivery && canSeeDelivery) {
    return [
      { category: "", links: [{ path: "/delivery", label: "sidebar.item.emailDelivery", icon: emailDelivery }] },
      {
        category: "sidebar.category.management",
        links: [
          { path: "/delivery/accounts", label: "sidebar.item.emailDelivery.accounts", icon: users },
          { path: "/delivery/domains", label: "sidebar.item.domains", icon: globeColor },
          canSeeSuppressionList && {
            path: "/delivery/suppression-list",
            label: "sidebar.item.emailDelivery.suppressionList",
            icon: suppressionList,
          },
        ],
      },

      ...(canSeeDeliveryTracemail
        ? [
            {
              category: "sidebar.category.analysis",
              links: [{ path: "/delivery/tracemail", label: "sidebar.item.etlive", icon: etliveColor }],
            },
          ]
        : []),
    ];
  }

  const canSeeEtlive = tm.permissions.includes("see_etlive");
  const canSeeAudits = tm.permissions.includes("see_audits");
  const canSeeSupport = tm.permissions.includes("see_support");
  const canSeeArchive = tm.permissions.includes("see_vault_email_accounts");
  const canManageDelegates = tm.permissions.includes("manage_vault_delegate");
  const canSeeDomains = tm.permissions.includes("see_domains");
  const canManageManagers =
    tm.permissions.includes("manage_managers") && (tm.is_customer_reseller || tm.is_customer_wholesale);
  const resellerOrWholesale = tm.is_customer_wholesale || tm.is_customer_reseller;

  const hideImports = !tm.permissions.includes("create_email_accounts") && !tm.permissions.includes("create_domains");

  const hideMigrations =
    !tm.permissions.includes("create_email_accounts") && !tm.permissions.includes("edit_email_accounts");

  return _.compact([
    ...(canSeeDomains
      ? [
          {
            category: "",
            links: [{ path: "/home", label: "sidebar.item.dashboard", icon: dashboardColor }],
          },

          {
            category: "sidebar.category.management",
            links: [
              { path: "/domains", label: "sidebar.item.domains", icon: globeColor },
              canSeeArchive && { path: "/archive", label: "sidebar.item.archive", icon: archiveColor },
              {
                path: "/customizations",
                label: "sidebar.item.customizations",
                icon: customizationsColor,
              },
            ],
          },

          {
            category: "sidebar.category.roles",
            links: [
              canManageManagers && {
                path: "/managers",
                label: "sidebar.item.managers",
                icon: managerColor,
                hide: !resellerOrWholesale,
              },
              {
                path: "/postmasters",
                label: "sidebar.item.postmasters",
                icon: postmasterColor,
              },

              canSeeArchive &&
                canManageDelegates && {
                  path: "/delegates",
                  label: "sidebar.item.delegates",
                  icon: delegateColor,
                },
            ],
          },

          {
            category: "sidebar.category.importsMigrations",
            links: [
              !hideImports && { path: "/imports", label: "sidebar.item.imports", icon: importsColor },
              !hideMigrations && {
                path: "/migrations",
                label: "sidebar.item.migrations",
                icon: migrationsColor,
              },
            ],
          },
        ]
      : []),
    ...(canSeeEtlive || canSeeAudits
      ? [
          {
            category: "sidebar.category.analysis",
            links: [
              canSeeEtlive && {
                path: "/tracemail",
                label: "sidebar.item.etlive",
                icon: etliveColor,
              },
              canSeeAudits && { path: "/audits", label: "sidebar.item.auditLogs", icon: registerColor },
            ],
          },
        ]
      : []),

    canSeeSupport && {
      category: "",
      links: [{ label: "sidebar.item.support", icon: supportColor, action: () => goToWHMCSTicketPage(tm) }],
    },
  ]);
};
